import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllContainerTypeGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllContainerTypeGroupsQuery = { __typename?: 'Query', getAllContainerTypeGroups: Array<{ __typename?: 'ContainerTypeGroup', id: number, name: string, category?: string | null, has_linked_stores: boolean, container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image_url?: string | null }> }> };


export const GetAllContainerTypeGroupsDocument = gql`
    query GetAllContainerTypeGroups {
  getAllContainerTypeGroups {
    id
    name
    category
    has_linked_stores
    container_types {
      id
      name
      image_url
    }
  }
}
    `;

/**
 * __useGetAllContainerTypeGroupsQuery__
 *
 * To run a query within a React component, call `useGetAllContainerTypeGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContainerTypeGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContainerTypeGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllContainerTypeGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContainerTypeGroupsQuery, GetAllContainerTypeGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContainerTypeGroupsQuery, GetAllContainerTypeGroupsQueryVariables>(GetAllContainerTypeGroupsDocument, options);
      }
export function useGetAllContainerTypeGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContainerTypeGroupsQuery, GetAllContainerTypeGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContainerTypeGroupsQuery, GetAllContainerTypeGroupsQueryVariables>(GetAllContainerTypeGroupsDocument, options);
        }
export type GetAllContainerTypeGroupsQueryHookResult = ReturnType<typeof useGetAllContainerTypeGroupsQuery>;
export type GetAllContainerTypeGroupsLazyQueryHookResult = ReturnType<typeof useGetAllContainerTypeGroupsLazyQuery>;
export type GetAllContainerTypeGroupsQueryResult = Apollo.QueryResult<GetAllContainerTypeGroupsQuery, GetAllContainerTypeGroupsQueryVariables>;